<script>
import { services } from '@src/utils/common-services'
import { appConfig } from '@src/app.config'

import { ValidationObserver } from 'vee-validate'

export default {
  components: {
    //  BIconLock,
    // Layout,

    ValidationObserver,
  },
  page: {
    title: 'Create',
    meta: [{ name: 'description', content: `Candidate ${appConfig.title}` }],
  },
  props: {
    edit: {
      type: Object,
      default() {
        return null
      },
    },
  },
  data() {
    return {
      select: null,

      location: null,
      canvas: null,
      currenProfile: null,
      previousApplicant1: {},
      previousApplicant2: {},
      locationOptions: [
        { id: 1, code: 'GB', label: 'United Kingdom' },
        {
          id: 2,
          code: 'GBS',
          label: 'Scotland',
        },
      ],
      selectOptions: [
        { id: 1, code: 'individual', label: 'Applying Alone' },
        {
          id: 2,
          code: 'couple',
          label: 'Applying with partner',
        },
        {
          id: 3,
          code: 'couple_single_login',
          label: 'Applying with partner(Single email)',
        },
      ],
      genderOptions: [
        { id: 1, code: 'male', label: 'Male' },
        {
          id: 2,
          code: 'female',
          label: 'Female',
        },
        {
          id: 3,
          code: 'others',
          label: 'Others',
        },
      ],
      titleOptions: [
        { id: 0, code: '-1', label: '-Select-' },
        { id: 1, code: 'mr', label: 'Mr.' },
        {
          id: 2,
          code: 'mrs',
          label: 'Mrs.',
        },
        { id: 3, code: 'ms', label: 'Ms.' },
        {
          id: 4,
          code: 'miss',
          label: 'Miss.',
        },
        {
          id: 5,
          code: 'Rev.',
          label: 'Rev.',
        },
        {
          id: 6,
          code: 'Dr.',
          label: 'Dr.',
        },
        {
          id: 7,
          code: 'Prof.',
          label: 'Prof.',
        },
      ],
      message: null,
      showSuccess: false,

      componentKey: 0,
      trySpin: false,
      showCreate: true,
      showApplicant1: true,
      showApplicant2: false,
      disabled: false,
      applicant1: {
        userProfile: {
          firstName: null,
          surname: null,
          gender: null,
          dateOfBirth: null,
          phoneNumber: null,
          location: null,
        },
        email: null,
      },
      applicant2: {
        userProfile: {
          firstName: null,
          surname: null,
          gender: null,
          dateOfBirth: null,
          phoneNumber: null,
          location: null,
        },
        email: null,
      },

      validateName: { required: true },
      validatePhone: {
        required: true,
        regex: /^(\+)?[\d]{9,13}$/,
      },
      validateEmail: { required: true, email: true },

      preloader: false,
    }
  },
  computed: {
    placeholders() {
      return {
        fname: 'First Name',
        surname: 'Last Name',
        phone: 'Enter phone number',
        email: 'Enter email address',
      }
    },
  },

  watch: {
    edit(oldVal, newVal) {
      this.setAppllicantEdit()
    },

    select(oldVal, newVal) {
      if (this.select === 'individual') {
        this.showCreate = true
      } else {
        this.showCreate = false
      }
    },
    classToggle(val, oldVal) {
      if (val !== oldVal) {
        this.scrollToTop()
      }
    },
    menuToggle(val, oldVal) {
      if (val !== oldVal) {
        // console.log(this.menuToggle)
        this.setMenubar({ newVal: true })
        this.$root.$emit('changeMenu', {
          data: true,
        })
      }
    },
  },
  mounted: function() {
    //  this.$refs.circle.animate(1.0)
    // console.log(state.userDetails)
    // this.profile = services.getCandidatesNameIcon(state.userDetails)
    if (this.edit !== null) {
      this.setAppllicantEdit()
    }
  },
  beforeDestroy() {
    this.$store.commit('jv/clearRecords', { _jv: { type: 'invite' } })
    // this.$store.commit('jv/clearRecords', { _jv: { type: 'applicant_profile' } })
  },
  beforeMount() {
    // this.getUser()
    // this.currentProfile = JSON.parse(window.localStorage.getItem('currentUser'))
    // (this.currentUser.type).toUpperCase()
    // this.percentage = 60 // this.currentUser.percentage

    this.img = null // this.currentUser.avatar
  },

  methods: {
    /*  setImage() {
      document.getElementById('img').src = this.canvas.toDataURL('image/png')

      this.img = this.canvas.toDataURL('image/png')
      var block = this.img.split(';')
      // Get the content type of the image

      this.profileImage = block[1].split(',')[1] // In this case "R0lGODlhPQBEAPeoAJosM...."
      this.cancel('modal-profile-upload', '')
      this.file = null
    }, */
    setAppllicantEdit() {
      this.location = this.edit.user.userProfile.location
      this.select = this.edit.applyingMode
      this.disabled = true
      var data1 = {
        userProfile: {
          firstName: this.edit.user.userProfile.firstName,
          surname: this.edit.user.userProfile.surname,
          gender: this.edit.user.userProfile.gender,
          dateOfBirth: this.edit.user.userProfile.dateOfBirth,
          phoneNumber: this.edit.user.userProfile.phoneNumber,
        },
        email: this.edit.user.email,
      }
      Object.assign(this.applicant1, data1)
      Object.assign(this.previousApplicant1, data1)
      if (this.select === 'couple' || this.select === 'couple_single_login') {
        var data2 = {
          userProfile: {
            firstName: this.edit.partner.userProfile.firstName,
            surname: this.edit.partner.userProfile.surname,
            gender: this.edit.partner.userProfile.gender,
            dateOfBirth: this.edit.partner.userProfile.dateOfBirth,
            phoneNumber: this.edit.partner.userProfile.phoneNumber,
          },
          email: this.edit.partner.email,
        }
        Object.assign(this.applicant2, data2)
        Object.assign(this.previousApplicant2, data2)
      }
    },
    getApplicant1() {
      this.showApplicant1 = !this.showApplicant1
      this.showApplicant2 = !this.showApplicant2
      this.componentKey++
      this.showCreate = false
    },
    getApplicant2() {
      this.componentKey++
      this.showApplicant1 = !this.showApplicant1
      this.showApplicant2 = !this.showApplicant2

      this.showCreate = true
    },

    scrollToTop() {
      window.scrollTo(0, 0)
    },

    async saveSettings() {
      this.trySpin = true
      var requestPayload = {}
      // console.log(this.currentUser)
      var valid = await this.$refs.create.validate()
      this.applicant1.userProfile.location = this.location
      this.applicant2.userProfile.location = this.location
      if (valid) {
        if (
          (this.select === 'couple' || this.select === 'couple_single_login') &&
          this.showApplicant1 === true
        ) {
          // this.applicant2.userProfile.location=this.location
          this.$refs.create.reset()
          this.getApplicant2()
          this.trySpin = false
        } else {
          if (this.edit === null) {
            requestPayload = {
              //  location: this.location,
              applyingMode: this.select,
              applicant1: this.applicant1,

              _jv: {
                type: 'invite',
              },
            }
            if (
              this.select === 'couple' ||
              this.select === 'couple_single_login'
            )
              Object.assign(requestPayload, { applicant2: this.applicant2 })
            this.$store
              .dispatch('jv/post', [
                requestPayload,
                {
                  url: '/applicant/profile/invite',
                  headers: services.getHeaderAuthorization(),
                },
              ])
              .then((response) => {
                this.trySpin = false
                this.$bvToast.show('candidate-create')
                this.message = 'New user is invited'
                var parent = this
                this.showSuccess = true
                setTimeout(() => {
                  parent.$bvToast.hide('candidate-create')
                  parent.message = null
                  this.$emit('view', true)
                }, 4000)
              })
              .catch((error) => {
                if (error.response) {
                  this.trySpin = false
                  for (let err of error.response.data.errors) {
                    this.message = err.detail
                  }
                } else {
                  this.trySpin = false

                  this.message = error.message
                }
                var parent = this
                this.showSuccess = false
                this.$bvToast.show('candidate-create')
                setTimeout(() => {
                  parent.$bvToast.hide('candidate-create')
                  parent.message = null
                }, 4000)
              })
          } else {
            requestPayload = {}

            var applicant1 = {}
            if (this.applicant1.email !== this.previousApplicant1.email)
              applicant1 = {
                userProfile: {
                  dateOfBirth: this.applicant1.userProfile.dateOfBirth,
                  firstName: this.applicant1.userProfile.firstName,
                  gender: this.applicant1.userProfile.gender,
                  phoneNumber: this.applicant1.userProfile.phoneNumber,
                  surname: this.applicant1.userProfile.surname,
                  location: this.location,
                },
                email: this.applicant1.email,
              }
            else {
              applicant1 = {
                userProfile: {
                  dateOfBirth: this.applicant1.userProfile.dateOfBirth,
                  firstName: this.applicant1.userProfile.firstName,
                  gender: this.applicant1.userProfile.gender,
                  phoneNumber: this.applicant1.userProfile.phoneNumber,
                  surname: this.applicant1.userProfile.surname,
                  location: this.location,
                },
                //  email: this.applicant1.email,
              }
            }
            requestPayload = {
              //  location: this.location,
              applicant1: applicant1,

              _jv: {
                type: 'applicant_profile',
                id: this.edit.id,
              },
            }
            if (
              this.select === 'couple' ||
              this.select === 'couple_single_login'
            ) {
              var applicant2 = {}
              if (this.applicant2.email !== this.previousApplicant2.email)
                applicant2 = {
                  userProfile: {
                    dateOfBirth: this.applicant2.userProfile.dateOfBirth,
                    firstName: this.applicant2.userProfile.firstName,
                    gender: this.applicant2.userProfile.gender,
                    phoneNumber: this.applicant2.userProfile.phoneNumber,
                    surname: this.applicant2.userProfile.surname,
                    location: this.location,
                  },
                  email: this.applicant2.email,
                }
              else {
                applicant2 = {
                  userProfile: {
                    dateOfBirth: this.applicant2.userProfile.dateOfBirth,
                    firstName: this.applicant2.userProfile.firstName,
                    gender: this.applicant2.userProfile.gender,
                    phoneNumber: this.applicant2.userProfile.phoneNumber,
                    surname: this.applicant2.userProfile.surname,
                    location: this.location,
                  },
                  //  email: this.applicant2.email,
                }
              }
              Object.assign(requestPayload, { applicant2: applicant2 })
            }

            this.$store
              .dispatch('jv/patch', [
                requestPayload,
                {
                  url: '/applicant/profile/' + this.edit.id,
                  headers: services.getHeaderAuthorization(),
                },
              ])
              .then((response) => {
                this.trySpin = false
                this.$bvToast.show('candidate-create')
                this.message = 'Applicant Profile is updated'
                var parent = this
                this.showSuccess = true
                setTimeout(() => {
                  parent.$bvToast.hide('candidate-create')
                  parent.message = null
                  this.$emit('view', true)
                }, 3000)
              })
              .catch((error) => {
                if (error.response) {
                  this.trySpin = false
                  for (let err of error.response.data.errors) {
                    this.message = err.detail
                  }
                } else {
                  this.trySpin = false

                  this.message = error.message
                }
                var parent = this
                this.showSuccess = false
                this.$bvToast.show('candidate-create')
                setTimeout(() => {
                  parent.$bvToast.hide('candidate-create')
                  parent.message = null
                }, 4000)
              })
          }
        }
      } else {
        this.trySpin = false
      }
    },
    cancel(name, form) {
      this.$bvModal.hide(name)
      this.errors.clear(form)
    },
  },
}
</script>

<template>
  <div>
    <div :class="$style.mainWraper">
      <div :class="$style.innerWraper">
        <div :class="$style.profileSettings">
          <div :class="$style.bodyContent">
            <div :class="$style.breadCrumbWraper">
              <h4 class="FL"
                >Applicant
                <BIcon
                  :class="$style.actionIcon"
                  class="mr5"
                  icon="chevron-right"
                ></BIcon>
                <span>{{ edit !== null ? 'Edit' : 'Create' }}</span>
              </h4>
              <button
                :class="$style.backToBtn"
                class="buttonCommon FR ml15"
                @click="$emit('view', true)"
                ><BIcon icon="eye" class="mr5"></BIcon>View Applicants
              </button>
              <div class="clear"></div>
            </div>
            <div class="FR FN-xs mt0-xs"> </div>
            <ValidationObserver ref="create" v-slot="{ handleSubmit }">
              <form
                :key="componentKey"
                :class="$style.form"
                @submit.prevent="handleSubmit(saveSettings)"
              >
                <div class="clear d-xl-block d-sm-block d-md-none"></div>
                <div
                  v-if="showApplicant1"
                  :class="[$style.UserWraper]"
                  class="pb20"
                >
                  <h5 :class="$style.subHeader">1. First Applicant</h5>
                  <div :class="$style.bodyContentBorder"></div>
                  <CommonBaseRadio
                    v-model="location"
                    name="location"
                    label="Location"
                    :more="{ options: locationOptions, disabled: disabled }"
                    :validation="{ required: true }"
                    @update="location = $event"
                  />
                  <!-- <div class="clear"></div> -->

                  <CommonBaseRadio
                    v-model="select"
                    name="select"
                    label="Select"
                    :more="{ options: selectOptions, disabled: disabled }"
                    :validation="{ required: true }"
                    @update="select = $event"
                  />
                  <CommonBaseInputText
                    v-model="applicant1.userProfile.firstName"
                    name="firstName"
                    label="First name"
                    :validation="{ required: true }"
                  />
                  <CommonBaseInputText
                    v-model="applicant1.userProfile.surname"
                    name="surname"
                    label="Surname"
                    :validation="{ required: true }"
                  />
                  <CommonBaseRadio
                    v-model="applicant1.userProfile.gender"
                    name="gender"
                    label="Gender"
                    :more="{ options: genderOptions }"
                    :validation="{ required: true }"
                    @update="applicant1.userProfile.gender = $event"
                  />
                  <CommonBaseDatePicker
                    v-model="applicant1.userProfile.dateOfBirth"
                    name="dateOfBirth"
                    type="date"
                    :validation="{ required: true }"
                    :more="{
                      validationNotAfter: -15,
                      placeholder: 'DD-MM-YYYY',
                    }"
                    label="Date Of Birth"
                  />
                  <CommonBaseInputText
                    v-model="applicant1.userProfile.phoneNumber"
                    name="phone"
                    label="Phone"
                    :more="{ placeholder: 'eg:- 01234567891' }"
                    :validation="validatePhone"
                  />
                  <CommonBaseInputText
                    v-model="applicant1.email"
                    name="email"
                    label="Email"
                    :validation="{ required: true, email: true }"
                  />
                  <div class="clear"></div>

                  <div v-if="showCreate" :class="[$style.formGroup]">
                    <div :class="[$style.buttonWrapper]" class=" mt30 mb30">
                      <button
                        class="buttonCommon buttonPrimary button FR"
                        type="submit"
                        v-on="$listeners"
                      >
                        <b-spinner
                          v-if="trySpin"
                          style="width: 18px; height: 18px;"
                          class="ml15 mr15"
                          label="Spinning"
                        ></b-spinner>
                        {{
                          !trySpin ? (edit !== null ? 'Update' : 'Create') : ''
                        }}
                      </button>
                      <div class="clear"></div>
                    </div>
                  </div>

                  <div v-else :class="[$style.formGroup]">
                    <div :class="[$style.buttonWrapper]" class=" mt30 mb30">
                      <button
                        class="buttonCommon buttonPrimary button FR"
                        type="submit"
                        v-on="$listeners"
                      >
                        Next
                      </button>
                      <div class="clear"></div>
                    </div>
                  </div>
                </div>
                <div v-if="showApplicant2" :class="[$style.UserWraper]">
                  <h5 :class="$style.subHeader">2. Partner Applicant</h5>
                  <div :class="$style.bodyContentBorder"></div>
                  <CommonBaseInputText
                    v-model="applicant2.userProfile.firstName"
                    name="firstName"
                    label="First name"
                    :validation="{ required: true }"
                  />
                  <CommonBaseInputText
                    v-model="applicant2.userProfile.surname"
                    name="surname"
                    label="Surname"
                    :validation="{ required: true }"
                  />
                  <CommonBaseRadio
                    v-model="applicant2.userProfile.gender"
                    name="gender"
                    label="Gender"
                    :more="{ options: genderOptions }"
                    :validation="{ required: true }"
                    @update="applicant2.userProfile.gender = $event"
                  />
                  <CommonBaseDatePicker
                    v-model="applicant2.userProfile.dateOfBirth"
                    name="dataOfBirth"
                    type="date"
                    :validation="{ required: true }"
                    :more="{
                      validationNotAfter: -15,
                      placeholder: 'DD-MM-YYYY',
                    }"
                    label="Date Of Birth"
                  />
                  <CommonBaseInputText
                    v-model="applicant2.userProfile.phoneNumber"
                    name="phone"
                    label="Phone"
                    :more="{ placeholder: 'eg:- 01234567891' }"
                    :validation="{ required: true }"
                  />
                  <CommonBaseInputText
                    v-if="select !== 'couple_single_login'"
                    v-model="applicant2.email"
                    name="email"
                    label="Email"
                    :validation="{ required: true, email: true }"
                  />
                  <div class="clear"></div>

                  <div v-if="showCreate" :class="[$style.formGroup]">
                    <div :class="[$style.buttonWrapper]" class=" mt30 mb30">
                      <button
                        class="buttonCommon buttonPrimary button FR"
                        type="submit"
                        v-on="$listeners"
                      >
                        <b-spinner
                          v-if="trySpin"
                          style="width: 18px; height: 18px;"
                          class="ml15 mr15"
                          label="Spinning"
                        ></b-spinner>
                        {{
                          !trySpin ? (edit !== null ? 'Update' : 'Create') : ''
                        }}
                      </button>
                      <button
                        class="buttonCommon buttonCancel button FR mr20 mb20-xs"
                        type="button"
                        @click="getApplicant1"
                      >
                        Back
                      </button>
                      <div class="clear"></div>
                    </div>
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
    <div :class="$style.toasterMainWrap">
      <b-toast id="candidate-create" solid no-auto-hide>
        <div
          class="d-flex"
          :class="
            !showSuccess
              ? [$style.loginToasterWraper, $style.error]
              : [$style.loginToasterWraper, $style.success]
          "
        >
          <div :class="$style.toasterLeft">
            <BIcon
              icon="chat-square-dots-fill"
              :class="$style.toasterIcon"
            ></BIcon>
          </div>
          <div :class="$style.toasterRight">
            <strong class="mr-auto" :class="$style.toasterHeader"
              >Notice!</strong
            >
            <p :class="$style.toasterContent">{{ message }}</p>
          </div>
          <div class="clear"></div>
        </div>
      </b-toast>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@design';

.form {
  padding: 20px 30px;
}
.formGroup {
  max-width: 500px;
}

.backToBtn {
  padding: 5px 14px !important;
  font-family: 'ProductSansRegular', Helvetica Neue, sans-serif,
    Apple Color Emoji;
  font-size: 15px !important;
  color: #fff !important;
  background: #ff5d16 !important;
  border-radius: 50px !important;
}

.subHeader {
  margin: 0;
  font-family: 'SourceSansProSemibold', Helvetica Neue, sans-serif,
    Apple Color Emoji;
  font-size: 20px;
  line-height: 29px;
  color: #959292;
}

// breadcrumb
.breadCrumbWraper {
  padding: 15px 30px;
  border-bottom: 2px solid #f8f9f9;

  h4 {
    margin: 0;
    font-family: 'SourceSansProSemibold', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 25px;
    line-height: 29px;
    color: #455d73;
  }
  span {
    font-family: 'SourceSansProRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 20px;
    font-weight: 600;
    line-height: 29px;
    color: #8c959f;
  }

  svg {
    font-size: 16px;
  }
}
// breadcrumb

.profileSettings {
  float: left;
  width: 100%;
}

// Page Title - Info text
.bodyContent {
  float: left;
  width: 100%;

  .contentHeader {
    font-family: 'OpenSansBold', Helvetica Neue, sans-serif, Apple Color Emoji;
    font-size: 22px;
    color: $color-main-title;
  }

  .contentInfo {
    font-family: 'LexendDecaRegular', Helvetica Neue, sans-serif,
      Apple Color Emoji;
    font-size: 13px;
    color: $color-sub-title;
  }
}

.bodyContentBorder {
  width: 100%;
  height: 2px;
  margin: 20px 0;
  background: #f8f9f9;
}
// Page Title - Info text

.mainWraper {
  width: 100%;
  min-height: calc(100vh - 55px);
  padding: 15px;
}

.innerWraper {
  position: relative;
  display: flex;
  min-height: calc(100vh - 85px);
  overflow: hidden;
  background: $color-body-inner-background;
  border: 1px solid #eee;
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.03);
}

@media (max-width: 767px) {
  .mainWraper {
    padding: 0 !important;
  }
  .breadCrumbWraper {
    h4 {
      font-size: 20px;
      line-height: 24px;
    }
    span {
      font-size: 18px;
      line-height: 24px;
    }
  }
  .profileSettings {
    padding: 0;
  }
}
</style>
